import { resourcesService } from "app/services";
import { useQuery } from "@tanstack/react-query";

export function useDecretosLegislativos() {
  const decretosLegislativos = useQuery({
    queryKey: ["decretos-legislativos"],
    queryFn: resourcesService.getDecretosLegislativos,
  });

  return decretosLegislativos;
}
